export const plMenus = {
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/pl-pl/',
            url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
            alt: 'Raisin',
        },
    ],
    navItems: [
        {
            id: '7c70fbdd-4e00-5gf2-8b47-87251d3456c5',
            title: 'Jak zacząć?',
            href: '/pl-pl/jak-zaczac/',
        },
        {
            id: '7d81gcdc-4e11-4fe1-8b47-87252d3534c6',
            title: 'Nasze oferty',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '9d42c71e-7190-4618-b581-38951fbcf547',
                        type: 'advanced',
                        title: 'Lokaty terminowe',
                        description: 'Korzystaj z konkurencyjnego, stałego oprocentowania w wybranym okresie',
                        href: '/pl-pl/lokaty/',
                        icon: 'fixedDepositIcon',
                        iconColor: '#61AFD2',
                    },
                    {
                        id: '9d42c71e-7190-4618-b581-38951fbcf534',
                        type: 'advanced',
                        title: 'Elastyczne produkty oszczędnościowe',
                        description: 'Zarabiaj bez ustalonego terminu i ze zmiennym oprocentowaniem',
                        href: '/pl-pl/konta-oszczednosciowe/',
                        icon: 'overnightMoneyIcon',
                        iconColor: '#9CD3E4',
                    },
                ],
            },
        },
        {
            id: '7d81gcdc-4e11-4fe2-9c58-878a2q7534c6',
            title: 'O Raisin',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '9d4v781e-7180-4618-b581-38951a8b5f547',
                        type: 'advanced',
                        title: 'O nas',
                        description: 'Wszystko, co chcesz wiedzieć o Raisin',
                        href: '/pl-pl/o-nas/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt4133ebadaf343c07/66ceeae0e20e4ad065037ab1/PL_Menu_Icons_O_nas.svg',
                        iconColor: '#003554',
                    },
                    {
                        id: '9d4g882x-b191-46s8-b581-42551an8uf824',
                        type: 'advanced',
                        title: 'Zostań partnerem',
                        description: 'Dołącz do naszych partnerów',
                        href: '/pl-pl/zostan-partnerem/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb99e6d7554e742ba/66ceeae0d31c5945b5530da6/PL_Menu_Icons_Zostan_partnerem.svg',
                        iconColor: '#003554',
                    },
                    {
                        id: '9d4g882x-b191-47s8-b581-426561an7uf824',
                        type: 'advanced',
                        title: 'Kontakt',
                        description: 'Jesteśmy tu, aby Ci pomóc',
                        href: '/pl-pl/kontakt/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt02f63d9e7a25ee15/66ceeae00044a409a23a74ac/PL_Menu_Icons_kontakt.svg',
                        iconColor: '#003554',
                    },
                    {
                        id: '9e4g992y-b191-47s8-b581-426561an7uf825',
                        type: 'advanced',
                        title: 'Banki',
                        description: 'Poznaj nasze banki partnerskie',
                        href: '/pl-pl/banki/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt91b794baba6d673f/PL_Menu_Icons_Banki.svg',
                        iconColor: '#003554',
                    },
                ],
            },
        },
        {
            id: '7d61gcdc-4e33-4fe2-9c58-878a2r7534c6',
            title: 'Baza wiedzy',
            href: '',
            subMenus: {
                main: [
                    {
                        id: '9d7v781e-728o-46i8-bs81-38951a1b2547',
                        type: 'advanced',
                        title: 'FAQ',
                        description: 'Znajdź odpowiedzi na często zadawane pytania',
                        href: 'https://pomoc.raisin.com/hc/pl-pl',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt68453dc5db1e4d3a/FAQs.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '9d6h992y-2i91-56s8-b591-42721a7uf824',
                        type: 'advanced',
                        title: 'System gwarantowania depozytów',
                        description: 'Wszystko o europejskim systemie gwarantowania depozytów',
                        href: '/pl-pl/system-gwarantowania-depozytow/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8e96e15c429c928b/Einlagensicherung.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '9d6g8810z-b100-4s78-b581-42551anvuf824',
                        type: 'advanced',
                        title: 'Informacje podatkowe',
                        description: 'Informacje na temat opodatkowania lokat',
                        href: '/pl-pl/informacje-podatkowe/',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt36b69e61c2b0a979/Steuerinformation.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '5d4de868-91cd-42cc-9358-08173aa5986f',
                        type: 'advanced',
                        title: 'Poradnik oszczędzania',
                        href: '/pl-pl/poradnik-oszczedzania/',
                        description: 'Odkryj sposoby na efektywne oszczędzanie',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltcff737ce31d3d64f/Guía_del_ahorro.svg',
                        iconColor: '#0E6CC5',
                    },
                    {
                        id: '4d3ajd48-91cd-42cc-9358-08173aa5986f',
                        type: 'advanced',
                        title: 'Poradnik inwestowania',
                        href: '/pl-pl/poradnik-inwestowania/',
                        description: 'Nasz poradnik inwestowania pieniędzy',
                        icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt7c20b2360d6a5bdf/Guía_de_la_inversión.svg',
                        iconColor: '#0E6CC5',
                    },
                ],
                sidebar: [
                    {
                        id: 'e776ab43-cce8-4cb1-9660-f10521d72340',
                        type: 'arrow',
                        title: 'Emerytura',
                        href: '/pl-pl/emerytura/',
                    },
                    {
                        id: '5330f3cf-1ecb-4689-b50f-83ca4fa184e8',
                        type: 'arrow',
                        title: 'Bezpieczeństwo',
                        href: '/pl-pl/bezpieczenstwo/',
                    },
                    {
                        id: 'b8401a9d-2cfb-4280-b7ad-d54ee8c31d7e',
                        type: 'arrow',
                        title: 'Oszczędzanie za granicą',
                        href: '/pl-pl/oszczedzanie-za-granica/',
                    },
                ],
            },
        },
    ],
    actionItems: [
        {
            id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
            title: 'Zaloguj się',
            href: '/pl-pl/login/',
            type: 'login',
        },
        {
            id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
            title: 'Zarejestruj się',
            href: '/pl-pl/register/',
            type: 'registration',
        },
    ],
};
//# sourceMappingURL=plMenus.js.map